import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Button, Container, Paper, useTheme, } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';
const services = [
  {
    icon: "🏡",
    title: "New Home Construction",
    desc: "Modern, high-quality homes tailored to your lifestyle.",
  },
  {
    icon: "🔨",
    title: "Knock Down & Rebuild",
    desc: "Replace your old home with a fresh, custom-built design.",
  },
  {
    icon: "🧱",
    title: "Custom Home Designs",
    desc: "Unique homes designed around your needs and vision.",
  },
  {
    icon: "🏘️",
    title: "Duplex & Dual Occupancy",
    desc: "Smart, space-efficient homes for living or investment.",
  },
  {
    icon: "📦",
    title: "House & Land Packages",
    desc: "Affordable, ready-to-build options in great locations.",
  },
];
export default function Section_5() {
  const [serviceCards, setServiceCards] = useState([]);
  const theme = useTheme();
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://urbancasabackendfiles.onrender.com/api/service-cards") // Adjust URL as needed
      .then((response) => response.json())
      .then((data) => setServiceCards(data))
      .catch((error) => console.error("Error fetching service cards:", error));
  }, []);

  return (
    <Box
      sx={{
        backgroundColor: "black",
        backgroundImage: 'url("/assets/section-5-bg-img.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        py: { xs: 5, sm: 8, md: 10 },
      }}
    >
      {/* Heading Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={4} >
          {/* Left Side - Heading */}
          <Grid item xs={12} md={4}>
            <Box display="flex" alignItems="center" gap={2} mb={2}>
              <img
                src="/assets/section-3-head-img.png"
                alt="heading-icon"
                style={{ width: "50px", height: "50px" }}
              />
              <Typography
                variant="h3"
                sx={{
                  color: "white",
                  fontSize: { xs: "2rem", sm: "2.5rem", md: "2.8rem" },
                  fontWeight: 700,
                }}
              >
                Our Services
              </Typography>
            </Box>
            <Typography
              sx={{
                color: "white",
                opacity: 0.8,
                fontSize: { xs: "1rem", md: "1.1rem" },
                textAlign:"justify"
              }}
            >
At UrbanCasa, we don't just build structures — we craft lifestyle experiences tailored to your dreams. As one of Australia’s leading construction companies, we offer a comprehensive suite of building solutions that blend cutting-edge design, superior craftsmanship, and personalized service. Whether it’s a sleek urban retreat, a sprawling family haven, or a bespoke architectural masterpiece, every project is a reflection of your unique vision — brought to life with passion, precision, and integrity.              
                 </Typography>
          </Grid>

          {/* Right Side - Services */}
          <Grid item xs={12} md={8} >
            <Grid container spacing={3} alignItems="center" justifyContent="center">
              {services.map((service, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <motion.div
                    whileHover={{ scale: 1.03 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: 3,
                        backgroundColor: "#1c1c1c",
                        borderRadius: "16px",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        color: "white",
                        border: "1px solid #333",
                        transition: "0.3s ease",
                        "&:hover": {
                          backgroundColor: "#272727",
                        },
                      }}
                    >
                      <Typography variant="h5" gutterBottom>
                        {service.icon} {service.title}
                      </Typography>
                      <Typography variant="body1" sx={{ opacity: 0.85 }}>
                        {service.desc}
                      </Typography>
                    </Paper>
                  </motion.div>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>

      {/* Cards Section */}
      <Container maxWidth="xl">
        <Grid container spacing={4} justifyContent="center" sx={{ mt: 2 }}>
          {serviceCards.map((card) => (
            <Grid item xs={12} sm={6} md={4} key={card._id}>
              <Link to="/Services">
              <Box
                sx={{
                  backgroundColor: "rgba(255, 255, 255, 0.05)",
                  borderRadius: 2,
                  overflow: "hidden",
                  boxShadow: 3,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                  p: 2,
                }}
              >
                {/* Image */}
                <Box
                  component="img"
                  src={card.imageUrl}
                  alt={card.title}
                  sx={{
                    width: "100%",
                    height: "30vh",
                    objectFit: "cover",
                    borderRadius: 1,
                  }}
                />

                {/* Title */}
                <Typography
                  variant="h5"
                  sx={{ color: "white", mt: 2, fontWeight: "bold" }}
                >
                  {card.title}
                </Typography>

                {/* Description */}
                <Typography
                  sx={{
                    color: "white",
                    mt: 1,
                    fontSize: { xs: "0.9rem", sm: "1rem" },
                    width: "90%",
                  }}
                >
                  {card.description}
                </Typography>
              </Box>
          </Link>
            </Grid>
          ))}
        </Grid>

        {/* Learn More Button */}
        <Box display="flex" justifyContent="center" mt={5}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#70B22F",
              color: "white",
              px: 4,
              py: 1.5,
              fontSize: { xs: "0.9rem", sm: "1rem" },
              borderRadius: "30px",
              "&:hover": { backgroundColor: "#5A8F26" },
            }}
            onClick={() => navigate("/Services")}
          >
            Learn More
          </Button>
        </Box>
      </Container>
    </Box>
  );
}
